import React from "react";
import { useLocation } from "react-router-dom";
import PaymentForm from "../../components/subscription/PaymentForm";
import { Lock } from "lucide-react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
var stripePromise = loadStripe("pk_live_51ROVPaEKC1pvS5ecYvHt6WUVTADAOermrHhDWa6p0rcuBxW5BvrNPGIQsEPqDI4PpddEc4ovBDjCCFEL8iIX9Pf700RhQFiClU"); // coloque sua chave pública do Stripe
var CheckoutPage = function () {
    var location = useLocation();
    var queryParams = new URLSearchParams(location.search);
    var planId = queryParams.get("plan_id");
    var planName = queryParams.get("plan_name");
    var planPrice = queryParams.get("plan_price");
    var planDescription = queryParams.get("plan_description");
    return (React.createElement("div", { className: "min-h-[calc(100vh-112px)] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-gray-100 flex flex-col items-center justify-center" },
        React.createElement("div", { className: "max-w-2xl w-full bg-gray-800 rounded-lg shadow-2xl p-8" },
            React.createElement("div", { className: "text-center mb-6" },
                React.createElement("h1", { className: "text-3xl font-extrabold text-white mb-2" }, "Concluir Assinatura"),
                React.createElement("p", { className: "text-gray-300" },
                    "Voc\u00EA est\u00E1 assinando o plano",
                    " ",
                    React.createElement("span", { className: "text-green-400 font-bold" }, planName || "Desconhecido"),
                    "."),
                planDescription && (React.createElement("p", { className: "text-gray-400 mt-2" }, planDescription)),
                planPrice && (React.createElement("p", { className: "text-xl font-bold text-white mt-4" },
                    "Pre\u00E7o: R$",
                    " ",
                    React.createElement("span", { className: "text-green-400" }, planPrice)))),
            React.createElement("div", { className: "bg-gray-900 rounded-lg p-6 shadow-lg" }, planId ? (React.createElement(Elements, { stripe: stripePromise },
                React.createElement(PaymentForm, { priceId: planId, planName: planName }))) : (React.createElement("p", { className: "text-center text-red-500" }, "Erro: Nenhum plano selecionado."))),
            React.createElement("div", { className: "mt-6 flex items-center justify-center gap-4 bg-gray-700 p-4 rounded-lg shadow-md w-full text-center" },
                React.createElement("p", { className: "text-gray-300 text-sm" }, "Utilizamos criptografia avan\u00E7ada para garantir a seguran\u00E7a das suas informa\u00E7\u00F5es.")),
            React.createElement("div", { className: "mt-6 text-center" },
                React.createElement(Lock, { className: "w-6 h-6 text-gray-400 inline-block" }),
                React.createElement("p", { className: "text-gray-400 text-sm mt-2" }, "Pagamento seguro via Stripe. N\u00E3o armazenamos informa\u00E7\u00F5es do seu cart\u00E3o.")))));
};
export default CheckoutPage;
